import React, { useEffect } from 'react';
import { PackageForm } from '../../../Components/Form';
import { FormLayout } from '../../../Components';
import { NewPackageIcon } from '../../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const PackageEdit = ({ handleToast }) => {
  useEffect(() => {
    document.title = `${t('common.edit')} ${t('Packages.packages')}`;
  }, []);

  return (
    <FormLayout
      title={t('Packages.packages')}
      Icon={NewPackageIcon}
      subtitle={t('common.edit')}
      iconstyle="general_module_icon"
      closeUrl="/packages"
      layoutBoxClass="uiux-form-redesign"
    >
      <PackageForm
        // title="Edit Package"
        type="edit"
        handleToast={handleToast}
      />
    </FormLayout>
  );
};

export default PackageEdit;
